export class ExcusableHistoryCreateModel {
  public RequestOrderExcusableId?: number;
  public Description?: string;
  public AgreementRef?: string;
  public Remark?: string;
  public Status?: number;
  public PartiallyAcceptedDays?: number | null;
  public Files?: any[];
}
